<template>
    <span>{{time}}</span>
</template>

<script>
export default {
    data() {
        return {
            time: 0,
            startTime: null
        }
    },
    methods: {
        countDown(time = 0) {
            this.time = time
            this.startTime = Date.now()

            this.calc()
        },
        calc() {
            const currentTime = Date.now()
            if (currentTime - this.startTime > 1000) {
                // this.$emit('update:time', this.time - 1)
                this.startTime = currentTime
                this.time -= 1
            }
            if (this.time) {
                window.requestAnimationFrame(this.calc)
            } else {
                this.$emit('finished')
            }
        },
        clear() {
            this.time = 0
            this.startTime = 0

            this.$emit('cleared')
        }
    }
}
</script>
